// extracted by mini-css-extract-plugin
module.exports = {"icon":"Slider_icon__3UQzt","slider":"Slider_slider__1BFDm","caption":"Slider_caption__29QDb"};